import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { ConfirmationState } from "@/routes/submit";
import type { Case } from "@/lib/cases";

export const Route = createFileRoute("/dev/pay-preview")({
  component: PayPreviewPage,
  head: () => ({
    meta: [{ title: "Dev — Payment Selection Preview" }],
  }),
});

const mockCase: Case = {
  id: "INV-2026-000000",
  method: "upload",
  fastTrack: false,
  createdAt: "2026-01-15T14:30:00.000Z",
  details: {
    vendor: "Flag City Towing and Recovery",
    invoiceDate: "2026-01-15",
    invoiceType: "Towing & Storage",
    totalAmount: "62,523.48",
    urgency: "normal",
  },
  files: [],
  status: "received",
  negotiationChosen: false,
};

function PayPreviewPage() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  return (
    <div className="min-h-screen bg-background">
      <div className="mx-auto max-w-6xl px-4 py-12">
        {mounted && <ConfirmationState c={mockCase} onAnother={() => {}} />}
      </div>
    </div>
  );
}
